import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllOpenBets, getOpenBetById } from '../../../services/openBets';


export const fetchAllOpenBets = createAsyncThunk(
    'sports/fetchAllOpenBets',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getAllOpenBets();
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch open bets.');
        }
    }
);
export const fetchOpenBetById = createAsyncThunk(
    'events/fetchOpenBetById',
    async (eventId, { rejectWithValue }) => {
        try {
            const response = await getOpenBetById(eventId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch open bet by id.');
        }
    }
);


const openBetsSlice = createSlice({
    name: 'openBets',
    initialState: {
        openBets: [],
        openBetDetails: [],
        loading: false,
        error: null
    },
    reducers: {
        clearOpenBets(state) {
            state.openBets = [];
            state.openBetDetails = [];
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllOpenBets.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllOpenBets.fulfilled, (state, action) => {
                state.loading = false;
                state.openBets = action.payload.data || [];
            })
            .addCase(fetchAllOpenBets.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch open bets';
                state.openBets = [];
            })

            .addCase(fetchOpenBetById.pending, (state) => {
                state.loading = true;
                state.error = null;
                // state.openBetDetails = [];
                state.openBets = [];
            })
            .addCase(fetchOpenBetById.fulfilled, (state, action) => {
                state.loading = false;
                // state.openBetDetails = action.payload.data || [];
                state.openBets = action.payload.data || [];
                state.error = null;
            })
            .addCase(fetchOpenBetById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch open bet details';
                // state.openBetDetails = [];
                state.openBets = [];
            });
    }
});

export const { clearOpenBets } = openBetsSlice.actions;

export default openBetsSlice.reducer;